/* eslint-disable */
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-browser-menu',
  templateUrl: './browser-menu.page.html',
  styleUrls: ['./browser-menu.page.scss']
})
export class BrowserMenuPage implements OnInit {
  constructor() {}

  ngOnInit() {}
}
